window.allowAdd = true
window.category_count = 0

delay = do ->
  timer = 0
  (callback, ms) ->
    clearTimeout timer
    timer = setTimeout(callback, ms)
    return

$(document).ready ->
  if $('.tips-index').length > 0
    tab = window.location.search.substr(1).split('tab=')[1]
    if !!tab
      if tab.indexOf('selected_manager_preset') == -1
        $("#tabs").tabs()
        $("#ui-id-#{tab}").click()

    $('.update-tip-type').keyup ->
      search_course = $(this)
      delay (->
        $(search_course).parents('form').submit()
        return
      ), 1500
      return

    $("#selected_manager_preset").on('change', ->
      $(this).parents('form').submit()
    )

    $('.add-tip-category-button').on('click', (e) ->
      e.preventDefault()
      window.allowAdd = false
      element = ''
      l_ids = $(this).parents('form').find('#language_ids').val()
      l_ids = l_ids.split(',')
      ln_id = $(this).data('language-id')
      t_t_id = $(this).data('tip-type-id')
      category_name = ''
      category_container = ''
      if t_t_id
        category_name = 'tip'
        category_container = t_t_id
      $(this).parents('.add-category-container').find('.add-category-input').hide()
      $(this).parents('.add-category-container').find('.add-tip-category-button').hide()
      $(this).parents('.add-category-container').find('.add-category-placeholder').show()
      text = $(this).parents('.add-category-container').find('.add-category-input').val()
      if text.length > 0
        $(this).parents('.add-category-container').find('.add-category-input').val('')
        count = parseInt(($('.category-index-number').length / $(this).parents('form').find('#language_ids').val().split(',').length) + 1)
        for l_id in l_ids
          if l_id == ln_id.toString()
            display =  'block'
            textt = text
            span_class = ''
          else
            display = 'none'
            textt = ''
            span_class = 'grayed-out'
          element += "
                      <div class='edit-category-container multi-lanuage-field #{category_name}-category-#{category_container}-#{l_id}' style='display: #{display};'>
                        <span class='category-index-number'>#{count}</span>
                        <span data-name='#{textt}' data-delete='false' class='order-item-name #{span_class}'>#{text}</span>
                        <i class='category-order-icon fa fa-bars right active'></i>
                        <input class='edit-category-input' id='category_#{window.category_count}_category' name='category[#{window.category_count}][category_multi][#{l_id}]' type='text' value='#{textt}'>
                        <button class='edit-category-button'>edit</button>
                      </div>"
        $("<div class='category-item ui-sortable-handle'>#{element}</div>").insertBefore('#tip_categories .edit-categories-main-container .clearfix')
        window.category_count--
    )

    $('.tip-language').click (event) ->
      $(this).parents('form').find('.tip-language').removeClass('selected')
      $(this).addClass('selected')
      l_id = $(this).data('language-id')
      t_id = $(this).data('tip-id')
  
      $(this).parents('form').find('.multi-lanuage-field').hide()
      $('#tip-title-'+t_id+'-'+l_id).css("display", "block")
      $('#tip-description-'+t_id+'-'+l_id).css("display", "block")

    $('.tip-category-language').click (event) ->
      $(this).parents('.modal').find('.tip-category-language').removeClass('selected')
      $(this).addClass('selected')
      l_id = $(this).data('language-id')
      t_t_id = $(this).data('tip-type-id')
      $(this).parents('.modal').find('.multi-lanuage-field').hide()
      $(this).parents('.modal').find('.add-category-container').hide()
      $('.tip-category-'+t_t_id+'-'+l_id).css("display", "block")
